import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { showRedirectPizzaAds } from '@/common/dateTime';
import NitroPayAnchorAd from './components/ads/NitroPayAnchorAd.vue';
import AdsToggle from './components/ads/AdsToggle.vue';
import AdBlockDetector from './components/ads/AdBlockDetector.vue';
import JfreaksRum from './components/ads/JfreaksRum.vue';
import FullresAnalytics from './components/FullresAnalytics.vue';
import GoogleAnalytics from './components/GoogleAnalytics.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (!_unref(showRedirectPizzaAds)())
      ? (_openBlock(), _createBlock(NitroPayAnchorAd, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(AdsToggle),
    _createVNode(AdBlockDetector),
    _createVNode(JfreaksRum),
    _createVNode(FullresAnalytics),
    _createVNode(GoogleAnalytics)
  ], 64))
}
}

})